import React, { useEffect, useState } from "react";
const FMH_VERTICAL = "/assets/images/fmh-text-vertical.svg";
const FMH_HORIZONTAL = "/assets/images/fmh-text-horizontal.svg";
const MOBILE_THRESHOLD = 815;

const FmhMigrationBanner = () => {
    const [isMobile, setIsMobile] = useState(false);
    
    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.innerWidth <= MOBILE_THRESHOLD);
        };
        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);
        
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    return (
        <div className="banner">
            <img
                src={isMobile ? FMH_HORIZONTAL : FMH_VERTICAL}
                alt="FollowMyHealth Logo"
                className="banner__logo"
            />
            <div className="banner__content">
                <h2 className="banner__header">
                    Coming Soon: A Better Way to Manage your Health!
                </h2>
                <p>
                    We're moving to <b>FollowMyHealth!</b> A new, improved way to
                    access your health information, connect with your providers,
                    and manage your care all in one place.&nbsp;
                    <a 
                        href="https://help.patientfusion.com/s/article/what-is-followmyhealth-and-how-can-i-get-access-to-my-personal-health-record" 
                        target="_blank" 
                        rel="noopener noreferrer"
                    >
                        Learn more here.
                    </a>
                </p>
            </div>
        </div>
    );
};

export default FmhMigrationBanner;
